import type { FC } from 'react';

import ReleaseNotes from './components/ReleaseNotes/ReleaseNotes';

const ReleasesPage: FC = () => {
  return (
    <div style={{ paddingTop: '64px' }}>
      <ReleaseNotes />
    </div>
  );
};

export default ReleasesPage;
